import { useDispatch, useSelector } from "react-redux";
import { axiosInstance, handleErrors } from "../auth";
import { saveAs } from "file-saver";
import exportVotesExcel from "lib/voteListExport";
// action config
const keyType = "list";
const perpage = 15;

export const UPDATE_FIELD = `${keyType}UpdateField`;
export const SET_LIST = `${keyType}SetList`;
export const CLEAR = `${keyType}Clear`;

export const updateFields = ({ prop, value }) => ({
  type: UPDATE_FIELD,
  payload: { prop, value },
});

export const useList = () => {
  const list = useSelector((state) => state.list);
  const dispatch = useDispatch();
  return {
    ...list,
    dispatch,
    clear,
    getList,
    listSearch,
    listFilter,
    create,
    remove,
    getSingle,
    update,
    restore,
    forceDelete,
    syncDelete,
    syncAdd,
    syncEdit,
    customRequest,
    dowloadFile,
    quickUpdate,
    createAndDownload,
    dowloadEexelReport,
    getDataList
  };
};

export const clear = () => ({
  type: CLEAR,
});

export const getList = (path, _page, _perPage) => async (dispath, getState) => {
  try {
    const {
      list: { page, perPage, searchKey, filters },
    } = getState();
    dispath(updateFields({ prop: "list", value: null }));
    dispath(updateFields({ prop: "load", value: true }));
    const params = new URLSearchParams({
      page: String(_page || page),
      perpage: String(_perPage || perPage),
    });
    Object.entries(filters || {}).forEach(([key, value]) => {
      if (value !== null && value !== undefined && value !== '') params.set(key, value);
    });
    if (searchKey) params.set('search', searchKey);
    const url = `${path.baseRoute}?${params.toString()}`;
    const {
      data: {
        data,
        meta,
        meta: { last_page, total, per_page, current_page, from, to },
      },
    } = await axiosInstance.get(url);

    dispath({
      type: SET_LIST,
      payload: {
        list: data,
        page: current_page,
        lastPage: last_page,
        perPage: per_page,
        total,
        from,
        to,
        meta:meta,
        type: path.type,
      },
    });
    dispath(updateFields({ prop: "load", value: false }));
  } catch (e) {
    handleErrors(e);
    dispath(updateFields({ prop: "load", value: false }));
  }
};

export const getDataList = (path, _page, _perPage) => async (dispath, getState) => {
  try {
    const {
      list: { page, perPage, searchKey },
    } = getState();
    dispath(updateFields({ prop: "list", value: null }));
    dispath(updateFields({ prop: "load", value: true }));
    let url = `${path.baseRoute}?page=${_page || page}&perpage=${
      _perPage || perPage
    }&search=${searchKey}`;


    const {
      data
    } = await axiosInstance.get(url);

    dispath({
      type: SET_LIST,
      payload: {
        list: data.data,
        page: 1,
        lastPage: 1,
        perPage: 1,
        total:data.data.length,
        from:1,
        to:data.data.length,
        meta:null,
        type: path.type,
      },
    });
    dispath(updateFields({ prop: "load", value: false }));
  } catch (e) {
    handleErrors(e);
    dispath(updateFields({ prop: "load", value: false }));
  }
};

export const listSearch = (path, searchKey) => async (dispath) => {
  dispath(updateFields({ prop: "searchKey", value: searchKey }));
  dispath(getList(path, 1));
};

export const listFilter = (path, filters = {}, searchKey = null, page, perPage) => async (dispath) => {
  dispath(updateFields({ prop: "filters", value: filters || {} }));
  if(searchKey !== null)
  {
    dispath(updateFields({ prop: "searchKey", value: searchKey }));
  }
  dispath(getList(path,page,perPage));
};

export const customRequest = (method = "get", url, data, cb,loading=true) => async (
  dispath
) => {
  try {
    if(loading)
    {
      dispath(updateFields({ prop: "load", value: true }));
    }

    const result = await axiosInstance({
      method,
      url,
      data,
    });
    dispath(updateFields({ prop: "load", value: false }));
    cb(result.data.data);
  } catch (e) {
    dispath(updateFields({ prop: "load", value: false }));

    handleErrors(e);
  }
};
export const create = (path, data, cb) => async (dispath) => {
  try {
    dispath(updateFields({ prop: "load", value: true }));
    await axiosInstance.post(path.baseRoute, data);
    dispath(updateFields({ prop: "load", value: false }));
    cb();
  } catch (e) {
    dispath(updateFields({ prop: "load", value: false }));

    handleErrors(e);
  }
};

export const createAndDownload = (path, data, cb) => async (dispath) => {
  try {
    dispath(updateFields({ prop: "load", value: true }));
    const resualt = await axiosInstance.post(path.baseRoute, data, {
      responseType: "blob",
    });
    dispath(updateFields({ prop: "load", value: false }));
    const blob = new Blob([resualt.data]);
    saveAs(blob, "report_" + Date.now().toString() + ".xlsx");
    cb();
  } catch (e) {
    dispath(updateFields({ prop: "load", value: false }));

    handleErrors(e);
  }
};

export const dowloadEexelReport = (path) => async (dispath, getState) => {
  try {
    const {
      list: { searchKey, filters },
    } = getState();

    let url = `${path.baseRoute}?pagination=false&download_excel=1`;

    if (filters) {
      Object.keys(filters).forEach((item) => {
        if (filters[item]) {
          url += `&${item}=${filters[item]}`;
        }
      });
    }

    if (searchKey) {
      url += `&search=${searchKey}`;
    }

    const resualt = await axiosInstance.get(url, {
      responseType: "blob",
    });

    const contentType = resualt.headers["content-type"] || "";

    if (
      path?.type === "votes" &&
      contentType.includes("application/json")
    ) {
      try {
        const text = await resualt.data.text();
        const payload = JSON.parse(text);
        const data =
          Array.isArray(payload?.data) && payload.data.length
            ? payload.data
            : [];

        if (!data.length) {
          console.warn("No data returned for votes Excel export");
          return;
        }

        exportVotesExcel(data);
        return;
      } catch (error) {
        console.error("Failed to parse votes Excel payload", error);
        throw error;
      }
    }

    const blob = new Blob([resualt.data]);
    saveAs(blob, "report_list_" + Date.now().toString() + ".xlsx");
  } catch (e) {
    handleErrors(e);
  }
};
export const dowloadFile = (url) => async (dispath) => {
  try {
    const resualt = await axiosInstance.get(url, {
      responseType: "blob",
    });

    const blob = new Blob([resualt.data]);
    saveAs(blob, "report_views" + Date.now().toString() + ".xlsx");
  } catch (e) {
    handleErrors(e);
  }
};

export const remove = (path, list, id, cb) => async (dispath) => {
  try {
    await axiosInstance.delete(`${path.baseRoute}/${id}`);
    cb();
  } catch (e) {

    handleErrors(e);
  }
};

export const getSingle = (path, id) => async (dispath) => {
  try {
    dispath(updateFields({ prop: "single", value: null }));
    const result = await axiosInstance.get(`${path.baseRoute}/${id}`);
    dispath(updateFields({ prop: "single", value: result.data.data }));
    dispath(updateFields({ prop: "type", value: path.type }));
  } catch (e) {
    handleErrors(e);
  }
};

export const update = (path, id, data, cb) => async (dispath) => {
  try {
    dispath(updateFields({ prop: "load", value: true }));
    await axiosInstance.put(`${path.baseRoute}/${id}`, data);
    dispath(updateFields({ prop: "load", value: false }));
    cb();
  } catch (e) {
    dispath(updateFields({ prop: "load", value: false }));
    handleErrors(e);
  }
};

export const quickUpdate = (path, id, data, cb) => async (dispath) => {
  try {
    dispath(updateFields({ prop: "load", value: true }));
    await axiosInstance.patch(`${path.baseRoute}/${id}`, data);
    dispath(updateFields({ prop: "load", value: false }));
    cb();
  } catch (e) {
    dispath(updateFields({ prop: "load", value: false }));
    handleErrors(e);
  }
};

// trash actions
export const restore = (path, list, id, cb) => async (dispath) => {
  try {
    await axiosInstance.put(`/panel/core/trash/${path.model}/${id}`);

    const newList = list.filter((item) => item.id !== id);
    dispath(updateFields({ prop: "list", value: newList }));
    if (!newList.length && cb) cb();
  } catch (e) {
    handleErrors(e);
  }
};

export const forceDelete = (path, list, id, cb) => async (dispath) => {
  try {
    await axiosInstance.delete(`/panel/core/trash/${path.model}/${id}`);

    const newList = list.filter((item) => item.id !== id);
    dispath(updateFields({ prop: "list", value: newList }));
    if (!newList.length && cb) cb();
  } catch (e) {
    handleErrors(e);
  }
};

// socket actions
export const syncDelete = (data) => (dispath, getState) => {
  try {
    const {
      list: { list, type, load, page },
    } = getState();
    if (data.model === type && !load && page === 1) {
      const newList = list.filter((item) => String(item.id) !== String(data.data.id));
      dispath(updateFields({ prop: "list", value: newList }));
    }
  } catch (e) {
    handleErrors(e);
  }
};

export const syncAdd = (data) => (dispath, getState) => {
  try {
    const {
      list: { list, type, load, page },
    } = getState();
    if (data.model === type && !load && page === 1) {
      let newList = list;
      if (newList.length >= perpage) {
        newList.pop();
      }
      newList = [data.data, ...newList];
      dispath(updateFields({ prop: "list", value: newList }));
    }
  } catch (e) {
    handleErrors(e);
  }
};

export const syncEdit = (data) => (dispath, getState) => {
  try {
    const {
      list: { list, type, load, page },
    } = getState();

    if (data.model === type && !load && page === 1) {
      let newList = list.filter((item) => item.id !== data.data.id);
      if (newList.length >= perpage) {
        newList.pop();
      }
      newList = [data.data, ...newList];
      dispath(updateFields({ prop: "list", value: newList }));
    }
  } catch (e) {
    handleErrors(e);
  }
};
